// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"74ca3855","815":"a049939e"}[chunkId] + ".chunk.js";
};